import injector from 'vue-inject'
// import nanoid from 'nanoid'
import modulesType from '../types/modules'

const state = {
  modules: [],
  module: {
    id: null,
    path: null,
    endpoints: [],
  },
}

const getters = {
  [modulesType.getters.getModules](state) {
    return state.modules
  },
  [modulesType.getters.getModule](state) {
    return state.module
  },
  [modulesType.getters.getModuleByKey](state) {
    // console.log(state.modules, 'state.modules')
    return (key) => state.modules.find(item => item.keyModule === key)
  },
  [modulesType.getters.getEndpointForList](state) {
    const endpoint = state.module.endpoints.find(item => item.alias === 'listar')
    if (endpoint) {
      return `${state.module.path}${endpoint.slug}`
    }
    return undefined
  },
  [modulesType.getters.getEndpointForExport](state) {
    const endpoint = state.module.endpoints.find(item => item.alias === 'export')
    if (endpoint) {
      return `${state.module.path}${endpoint.slug}`
    }
    return undefined
  },
}

const mutations = {
  [modulesType.mutations.setModules](state, { modules }) {
    state.modules = modules
  },
  [modulesType.mutations.setModule](state, { id, path, endpoints }) {
    state.module.id = id
    state.module.path = path
    state.module.endpoints = endpoints
  },
}

const actions = {
  [modulesType.actions.setModules]: injector.encase(['MenuService'], (MenuService) => async ({ commit }, { modules }) => {
    // let key
    MenuService.removeAllItem()
    modules.forEach((item) => {
      MenuService.addItem({
        title: item.name,
        key: item.keyModule,
        icon: 'fe fe-bookmark',
        url: `/modules/${item.keyModule}`,
      })
    })
    commit(modulesType.mutations.setModules, { modules })
  }),

  [modulesType.actions.setModule]: injector.encase(['MaintenanceService'], (MaintenanceService) => async ({ commit, getters }, { key }) => {
    const module = getters[modulesType.getters.getModuleByKey](key)
    // const endpoints = await MaintenanceService.endpoints(module.id)
    commit(modulesType.mutations.setModule, { ...module })
  }),
}

export default {
  state,
  getters,
  mutations,
  actions,
}
